export default {
  ICBC: ['#EC4B4B', '#F66258'],
  CCB: ['#5F78F3', '#66A4E2'],
  BOC: ['#EC4B4B', '#F66258'],
  ABC: ['#4AAD95', '#87CBAA'],
  CMB: ['#EC4B4B', '#F66258'],
  CIB: ['#5F78F3', '#66A4E2'],
  CEB: ['#FF7C57', '#FFB969'],
  SPDB: ['#5F78F3', '#66A4E2'],
  PAB: ['#FF7C57', '#FFB969'],
  GDB: ['#EC4B4B', '#F66258'],
  PSBC: ['#4AAD95', '#87CBAA'],
  CITIC: ['#EC4B4B', '#F66258'],
  SHB: ['#5F78F3', '#66A4E2'],
  CMBC: ['#5F78F3', '#66A4E2'],
  HXB: ['#EC4B4B', '#F66258'],
  BOB: ['#EC4B4B', '#F66258'],
  CZBANK: ['#EC4B4B', '#F66258'],
  CBHB: ['#5F78F3', '#66A4E2'],
  EGF: ['#5F78F3', '#66A4E2'],
  QDCCB: ['#EC4B4B', '#F66258'],
  DEFAULT: ['#FF7C57', '#FFB969']
}